export default {"src":"/_next/static/media/mom_prime_logo.2f46a834.svg","height":44,"width":164,"blurWidth":0,"blurHeight":0};